// extracted by mini-css-extract-plugin
export default {"button":"TextButton_button__3I5Xd","disabled":"TextButton_disabled__deWZE"};